'use client';

import { OnbForm } from '@/components/form';
import { setAdditionalData } from '@/redux/additionalDataSlice';
import { Stack, Typography } from '@mui/material';
import { getOrderCredentialJWT } from '@repo/ecommerce-api';
import { OrderCard } from '@repo/ui';
import { deleteClientCookie, parseJwt, setClientCookie } from '@repo/utils';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import StepWrapper from './flow/stepWrapper';

export default function InitializePayments({ orderToken, internal }: { orderToken: string; internal: boolean }) {
  const decodedJwt = parseJwt(orderToken) as getOrderCredentialJWT;
  const [disableForm, setDisableForm] = useState(false);
  const { merchantName, merchantOrderId, price } = decodedJwt;
  const router = useRouter();
  const dispatch = useDispatch();
  const isEfectivoC = decodedJwt.policyProduct === 'EFECTIVOC';

  useEffect(() => {
    dispatch(
      setAdditionalData({
        returnURLInitialize: decodedJwt.returnURLError,
        integrationTypeInitialize: decodedJwt.integrationType,
        orderIdInitialize: decodedJwt.orderId,
      }),
    );
  }, [decodedJwt, dispatch]);

  const initializeFlow = () => {
    dispatch(
      setAdditionalData({
        returnURLError: decodedJwt.returnURLError,
        returnURLSuccess: decodedJwt.returnURLSuccess,
        internal: internal,
        orderId: decodedJwt.orderId,
        integrationType: decodedJwt.integrationType,
        policyProduct: decodedJwt.policyProduct,
        requestedAmount: '',
        documentNumber: decodedJwt.documentNumber,
        merchantName: decodedJwt.merchantName,
        price: decodedJwt.price,
        merchantOrderId: decodedJwt.merchantOrderId,
      }),
    );
    setDisableForm(true);
    deleteClientCookie(['instanceId', 'orderToken', 'requestedAmount', 'utmData', 'accessKey']);
    setClientCookie('orderToken', orderToken);
    setClientCookie('integrationType', decodedJwt.integrationType);
    setClientCookie('policyProduct', decodedJwt.policyProduct);
    router.push(`/flow?internal=${internal}`);
  };
  return (
    <StepWrapper>
      <Stack
        sx={{
          gap: 2,
        }}
      >
        <Typography variant="h1">
          {isEfectivoC ? 'Estás a un paso de tu préstamo' : 'Tu compra en cuotas con Directo'}
        </Typography>
        <Typography component="p" variant="subtitle2">
          Revisá los detalles de la operación y seguí adelante.
        </Typography>
        <OrderCard merchantName={merchantName} merchantOrderId={merchantOrderId} price={price} isLoan={isEfectivoC} />
      </Stack>
      <OnbForm onSubmit={initializeFlow} disabled={disableForm} forceInternal={internal} />
      <Stack
        sx={{
          gap: 2,
          width: '100%',
        }}
      ></Stack>
    </StepWrapper>
  );
}
